module.exports = __webpack_public_path__ + "static/media/147.dbf36629.jpg";